<div (click)="startCalculate()" id="calculate-area" class="esri-widget--button esri-widget esri-interactive" [ngClass]="{'js-btn-active': isGeometryCalculator}" title="Обчислити площу/довжину">
  <span class="esri-icon-measure-area"></span>
</div>